















































































import Enumerable from "linq";
import { Component, Emit, Mixins, Prop, Watch } from "vue-property-decorator";
import { DomainRegistry } from "../../../../../domain";
import { DocumentSummary } from "../../../../../domain/document";
import { Patient } from "../../../../../domain/patient";
import { ModelEditableMixin, ModalPresentableMixin, PdfStyleDrawableMixin, TabContainableMixin } from "../../../../system/mixins";
import { TabSelector } from "../../../../system/selectors";
import { PdfViewer } from "../../../../system/viewers";
import { IDrawableItemEditable } from "../../IDrawableItemEditable";
import { EditingDocument } from "../..";
import { DocumentQuotableMixin, DocumentAttributesEditableMixin } from "../../mixins";
import { ITabDefinition } from "./ITabDefinition";
import { DocumentDialogSelector, DocumentDataViewer } from "./existingDocument";
import { QuoteBehaviorKinds } from "../../../../../domain/format";

@Component({
  components: {
    DocumentDialogSelector,
    TabSelector,
    PdfViewer,
    DocumentDataViewer,
  }
})
export default class DocumentViewTool extends Mixins<
  ModelEditableMixin
  & ModalPresentableMixin
  & PdfStyleDrawableMixin
  & TabContainableMixin
  & DocumentQuotableMixin
  & DocumentAttributesEditableMixin
>(
  ModelEditableMixin,
  ModalPresentableMixin,
  PdfStyleDrawableMixin,
  TabContainableMixin,
  DocumentQuotableMixin,
  DocumentAttributesEditableMixin
) {
  static readonly Tabs: {[key: string]: ITabDefinition} = {
    data: {
      name: "データ",
      description: "文書のデータ一覧を表示します。",
    },
  };
  // vmのメンバでないとテンプレートからバインドできないのでフィールドとして定義.(変化しないのでリアクティブじゃなくていい.)
  readonly dataTab: any = DocumentViewTool.Tabs.data;

  $refs!: {
    documentDialogSelector: DocumentDialogSelector,
  };

  mounted(): void {
    this.initializeTabs();
  }

  initializeTabs(): void {
    this.tabs = Enumerable.from(this.additionalTabs ? this.additionalTabs : [])
      .concat([ this.dataTab ])
      .where(t => !!t)
      .toArray();
  }

  @Prop()
  source: IDrawableItemEditable;

  @Prop({ default: "right" })
  containerTabPosition: string;

  @Prop()
  additionalTabs: ITabDefinition[];

  data(): any {
    return {
      selectedDocument: null as DocumentSummary,
      isLoading: false,
      shouldPreviewPdfLikeEditing: false,
      pdfSource: "",
      filteredOptions: null as DocumentSummary[],
      filteredText: "",
      isQuotableFormat: false,
    };
  }
  selectedDocument: DocumentSummary;
  isLoading: boolean;
  shouldPreviewPdfLikeEditing: boolean;
  pdfSource: string;
  filteredOptions: DocumentSummary[];
  filteredText: string;
  isQuotableFormat: boolean;

  get shouldShowAdditionalContent(): boolean {
    return this.selectedTab
        && Enumerable.from(this.additionalTabs).any(t => this.selectedTab.name === t.name);
  }

  get isPostable(): boolean {
    return this.isDocumentSelected
      && this.editingSource
      && this.editingSource.isAlreadyInitialized
      && this.isQuotable;
  }

  get isEditingDocumentPostable(): boolean {
    return this.editingDocumentQuoteBehaviorKind !== QuoteBehaviorKinds.Disabled;
  }

  get isDocumentSelected(): boolean {
    return !!this.selectedDocument;
  }

  get isLayoutHorizontal(): boolean {
    return (this.containerTabPosition === "top")
        || (this.containerTabPosition === "bottom");
  }

  get tabLayoutClass(): string {
    return this.isLayoutHorizontal
      ? "horizontal"
      : "vertical";
  }

  get tabPosition(): string {
    return this.isLayoutHorizontal
      ? "left"
      : "top";
  }

  get isPreviewable(): boolean {
    return this.$configuration.behavior.document.editor.contents.documentView.previewWindow.isEnable;
  }

  get isPreviewLikeEditingEnable(): boolean {
    return this.$configuration.behavior.document.list.menu.previewLikeEditing.isEnable;
  }

  get isPreviewableLikeEditing(): boolean {
    return this.isReadable && !this.isUnmanaged;
  }

  get isReadable(): boolean {
    return this.selectedDocument && this.selectedDocument.isReadable;
  }

  get isUnmanaged(): boolean {
    return this.selectedDocument && this.selectedDocument.isUnmanaged;
  }

  get isQuotable(): boolean {
    return this.selectedDocument && this.selectedDocument.isQuotable && this.isQuotableFormat;
  }

  get editingDocumentId(): number {
    const source = this.editingSource ? this.editingSource.source : null;
    return source ? source.documentId : null;
  }

  get editingDocumentName(): string {
    return this.readPropertyOrDefault(s => s.attributes.format.name, "");
  }

  get patient(): Patient {
    return this.readPropertyOrDefault(s => s.attributes.patient, null);
  }

  get editingDocumentQuoteBehaviorKind(): QuoteBehaviorKinds {
    return this.readPropertyOrDefault(s => s.attributes.quoteBehaviorKind, null);
  }

  get isOtherPatientDocument(): boolean {
    return this.patient && this.selectedDocument && this.patient.id !== this.selectedDocument.patientNo;
  }

  get isSelectedDocumentUnmanaged(): boolean {
    return this.selectedDocument && this.selectedDocument.isUnmanaged;
  }

  get shouldRenderDocumentPdfByPlugin(): boolean {
    return this.$configuration.behavior.document.viewer.pdfRendering.shouldRenderUnmanagedDocumentByPlugin && this.isSelectedDocumentUnmanaged;
  }

  async postDocument(): Promise<void> {
    try {
      this.beginModal();
      if (this.editingSource.currentSection.itemSetId !== 0) {
        this.$error(
          "引用・転記エラー",
          "続紙を選択中は引用・転記ができません。",
        );
        return;
      }
      const index = await this.$commonDialogs.confirmation.confirmDangerCancel(
        null,
        ["編集中の文書に引用・転記します。編集中の内容に上書きして本当によろしいですか？"],
        "上書きする"
      );
      if (index !== 0) { return; }
      const repository = DomainRegistry.document.getDocumentRepository();
      this.isLoading = true;
      this.$logger.info("引用・転記元の文書を取得します。ID:" + this.selectedDocument.id);
      repository.getDocumentForQuotation(this.selectedDocument.patientNo, this.selectedDocument.id)
        .then(async d => {
          const editingDocument = new EditingDocument(d);
          try {
            await editingDocument.initialize(); // 計算式の更新等初期化する.
          } catch (e) {
            this.$error("エラー", e.message, e);
          }
          this.quoteDocumentAsync(d)
          .then(() => {
            this.isLoading = false;
            this.quoteCompleted();
          })
          .catch(e => {
            this.$error(
              "引用・転記失敗",
              "文書を引用・転記できませんでした。",
              e
            );
            this.isLoading = false;
          });
        })
        .catch(e => {
          this.$error(
            "文書取得エラー",
            "文書が取得できませんでした。",
            e
          );
          this.isLoading = false;
        });
    } finally {
      this.endModal();
    }
  }

  showPdfFileView(): void {
    const param: any = {
      name: this.selectedDocument.documentName,
      encodedUri: encodeURIComponent(this.selectedDocument.previewSource.source),
    };
    this.$openWindow("/ShowDocumentSimply", param);
  }

  showDocumentSelectDialog(): void {
    if (this.$refs.documentDialogSelector) {
      this.$refs.documentDialogSelector.select();
    }
  }

  async updatePdfSource(): Promise<void> {
    this.pdfSource = ""; // PDFの読込が始まるまでに少し間があるので先にクリアする
    this.pdfSource = this.shouldPreviewPdfLikeEditing
      ? await this.getPreviewPdfLikeEditingSource()
      : this.selectedDocument.previewSource.source;
  }

  async getPreviewPdfLikeEditingSource(): Promise<string> {
    const repository = DomainRegistry.document.getDocumentRepository();
    const source = await repository.createPreviewLikeEditingSource(this.selectedDocument.id, this.selectedDocument.patientNo, this.selectedDocument.edition);
    return source.source;
  }

  get indexOfSelectedDocument(): number {
    return this.filteredOptions.findIndex(e => e.id === this.selectedDocument.id);
  }

  get isLeftButtonEnable(): boolean {
    return this.selectedDocument && this.filteredOptions
      && this.indexOfSelectedDocument > 0;
  }

  get isRightButtonEnable(): boolean {
    return this.selectedDocument && this.filteredOptions
      && this.indexOfSelectedDocument < this.filteredOptions.length - 1;
  }

  moveToPreviousDocument(): void {
    if (this.isLeftButtonEnable) {
      this.selectedDocument = this.filteredOptions[this.indexOfSelectedDocument - 1];
    }
  }

  moveToNextDocument(): void {
    if (this.isRightButtonEnable) {
      this.selectedDocument = this.filteredOptions[this.indexOfSelectedDocument + 1];
    }
  }

  @Watch("selectedDocument")
  async onSelectedDocumentChanged(newValue: DocumentSummary, oldValue: DocumentSummary) {
    this.isQuotableFormat = false;
    if (newValue) {
      if (!oldValue && !this.isEditingDocumentPostable) {
        this.$warn("引用・転記不許可", "編集中の文書の" + this.$wording.format.name + "は引用・転記が許可されていません。");
      }

      this.filteredOptions = this.$refs.documentDialogSelector.filteredOptions;
      this.filteredText = this.$refs.documentDialogSelector.filteredText;

      // 特に待つ必要が無いのでawaitはしない
      this.isQuotableFormatByMapping(newValue.formatOriginalId)
      .then(isQuotable => {
        // 取得している間に文書を切り替えた場合の対策でformatOriginalIdを比較している
        if (!!this.selectedDocument && newValue.formatOriginalId === this.selectedDocument.formatOriginalId) {
          this.isQuotableFormat = isQuotable;
        }
      });
      await this.updatePdfSource();
    }
  }

  async isQuotableFormatByMapping(sourceFormatOriginalId: number): Promise<boolean> {
    if (!this.$configuration.behavior.document.editor.quotation.formatFilter.isEnable) {
      // 相澤病院以外では不必要にAPIを叩くだけなのでスキップしている
      return true;
    }
    if (!this.formatOriginalId || !sourceFormatOriginalId) { return false; }
    if (this.formatOriginalId === sourceFormatOriginalId) {
      return true;
    }
    const repo = DomainRegistry.format.getFormatRepository();
    const quotableFormatIds = await repo.getQuotableDestinationFormatIds(sourceFormatOriginalId);
    return (quotableFormatIds.length === 0) || quotableFormatIds.some(id => id === this.formatOriginalId);
  }

  @Watch("shouldPreviewPdfLikeEditing")
  async onShouldPreviewPdfLikeEditingChanged() {
    await this.updatePdfSource();
  }

  @Watch("tabPosition")
  async onTabPositionChanged() {
    // keep-aliveタグの子のコンポーネントのactivatedを動作させるためisTransitioningを一度切り替える
    this.isTransitioning = true;
    await this.$nextTick();
    this.isTransitioning = false;
  }

  @Emit()
  quoteCompleted(): void {}
}
